import {IOrder} from '../../../models/Order/IOrder';

export const normalizeOrderIds = (order: IOrder): IOrder => {
    const orderId = order.id;

    return {
        ...order,
        prepayment: order.prepayment ? {...order.prepayment, orderId} : order.prepayment,
        subOrders: order.subOrders?.map(subOrder => ({
            ...subOrder,
            orderId,
            images: subOrder.images?.map(image => ({
                ...image,
                orderId,
                subOrderId: subOrder.id,
            })),
        })),
    };
};
